import countGlobalVersions from './countGlobalVersions.js'
import findOne from './findOne.js'
import findVersionByID from './findVersionByID.js'
import findVersions from './findVersions.js'
import restoreVersion from './restoreVersion.js'
import update from './update.js'

export default {
  countGlobalVersions,
  findOne,
  findVersionByID,
  findVersions,
  restoreVersion,
  update,
}
